import { render, staticRenderFns } from "./page-main-title.vue?vue&type=template&id=11c771a6&scoped=true&lang=pug&"
import script from "./page-main-title.vue?vue&type=script&lang=js&"
export * from "./page-main-title.vue?vue&type=script&lang=js&"
import style0 from "./page-main-title.vue?vue&type=style&index=0&id=11c771a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c771a6",
  null
  
)

export default component.exports